<template>
  <div
    class="flex-column items-center text-center justify-between w-full md:w-64 select-none px-2 md:px-0 overflow-x-hidden md:overflow-x-visible"
  >
    <div v-if="filtersData.length == 0">
      <li v-for="skeleton in Array.from({ length: 12 })" class="pb-4 list-none">
        <SkeletonLoader class="w-full h-[15px]" />
      </li>
    </div>
    <div v-else>
      <div class="hidden md:block">
        <Datepicker :modelValue="selectedDate" @update:model-value="dateCallback" :isDark="isDark" />
      </div>
      <SmartSlider
        v-if="priceBuckets"
        :title="$t('Your Budget (per person)')"
        :min="minMax['min']"
        :selectedMin="minMax['selectedMin']"
        :max="minMax['max']"
        :selectedMax="minMax['selectedMax']"
        :buckets="priceBuckets"
        :rangeTooltip="rangeTooltip"
        :formatter="formatter(currentCurrency)"
        :currency="currentCurrency"
        @newSliderRange="priceCallback"
      />
    </div>
    <FiltersListSection
      :filtersData="filtersData"
      :filterSelectedCallback="toggleFilters"
      :selectedFilters="selectedFilters"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import Datepicker from './Filters/Datepicker.vue';

// const priceValue = ref(null); // Initialize with default values
let priceBuckets = ref(null);
let filterMin = ref(null);
let filterMax = ref(null);
const { currentCurrency } = useCurrency();
//console.log('tooltip', currentCurrency);

const colorMode = useColorMode();
const isDark = computed({
  get() {
    return colorMode.value === 'dark';
  },
  set() {
    colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark';
  },
});

const emit = defineEmits(['updateFilters']);

const props = defineProps({
  filtersData: {
    type: Object,
    required: true,
  },
  priceData: {
    type: Object,
    required: true,
  },
  filterSelectedCallback: {
    type: Function,
    required: true,
  },
  dateSelectedCallback: {
    type: Function,
    required: true,
  },
  priceSelectedCallback: {
    type: Function,
    required: true,
  },
  selectedFilters: {
    type: Array,
    required: true,
  },
  selectedDate: {
    type: Date,
  },
  selectedPriceInterval: {
    type: Object,
  },
});

// Watch for changes in filtersData and update the value accordingly
watch(
  () => props.filtersData,
  (newFiltersData) => {
    if (
      newFiltersData &&
      newFiltersData['Price'] &&
      newFiltersData['Price']['filters'] &&
      newFiltersData['Price']['filters'][0]
    ) {
      const { min, max, interval, prices } = newFiltersData['Price']['filters'][0];
      if (newFiltersData['Price']['filters'][0]['max'] > 1) {
        priceBuckets = prices;
        filterMin = min;
        filterMax = max;
        /*let selectedMin = min;
        let selectedMax = max;
        if (props.selectedPriceInterval) {
          selectedMin = props.selectedPriceInterval.min;
          selectedMax = props.selectedPriceInterval.max;
        }
        minMax = {min: min, max: max, selectedMin: selectedMin, selectedMax: selectedMax};*/
        //rangeTooltip.value = `${ currentCurrency.value } ${ selectedMin.toString() } - ${ currentCurrency.value } ${ selectedMax.toString() }`;
      } else {
        priceBuckets = ref(null);
        // minMax = ref(null);
        // rangeTooltip.value = '';
      }
    }
  },
  { immediate: true, deep: true },
);

const minMax = computed(() => {
  if (!priceBuckets) return null;

  let selectedMin = filterMin;
  let selectedMax = filterMax;
  if (props.selectedPriceInterval && Object.keys(props.selectedPriceInterval).length) {
    selectedMin = props.selectedPriceInterval.min;
    selectedMax = props.selectedPriceInterval.max;
  }
  return { min: filterMin, max: filterMax, selectedMin: selectedMin, selectedMax: selectedMax };
});

const rangeTooltip = computed(() => {
  if (!priceBuckets) return '';
  return `${currentCurrency.value} ${minMax.value.selectedMin.toString()} - ${
    currentCurrency.value
  } ${minMax.value.selectedMax.toString()}`;
});

function toggleFilters(key) {
  emit('updateFilters', key);
  props.filterSelectedCallback(key);
}

function dateCallback(date) {
  props.dateSelectedCallback(date);
}

function priceCallback(minMaxObject) {
  /*let minMaxStr = `${minMaxObject['min']}-${minMaxObject['max']}`;
  minMax.selectedMin = minMaxObject['min'];
  minMax.selectedMax = minMaxObject['max'];*/
  // rangeTooltip.value = `${ currentCurrency.value } ${ minMax.selectedMin.toString() } - ${ currentCurrency.value } ${ minMax.selectedMax.toString() }`;
  props.priceSelectedCallback(minMaxObject);
}

function formatter(currency) {
  return function (val) {
    return `${currency} ${val}`;
  };
}
</script>

<script>
import SmartSlider from '~/components/Filters/SmartSlider.vue';

export default {
  components: {
    SmartSlider,
  },
  computed: {
    buttonClasses() {
      return `
        text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300
        font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center
        dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800
      `;
    },
    dropdownClasses() {
      return `
        z-10 w-56 p-3 bg-white rounded-lg shadow dark:bg-gray-700
      `;
    },
    checkboxClasses() {
      return `
        w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600
        dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500
      `;
    },
  },
};
</script>
